import { render, staticRenderFns } from "./pushMessageDetail.vue?vue&type=template&id=1169a05a&"
import script from "./pushMessageDetail.vue?vue&type=script&lang=js&"
export * from "./pushMessageDetail.vue?vue&type=script&lang=js&"
import style0 from "./pushMessageDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports